import { useCallback } from 'react'
import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Heading from 'LuxKit/Typography/Heading'
import TextInput from 'components/Common/Form/Input/TextInput'
import LineArrowRightIcon from 'LuxKit/Icons/line/LineArrowRightIcon'
import { formToObject } from 'lib/forms/formToObject'
import Clickable from 'components/Common/Clickable'
import { setAuthTokenToCookies } from 'api/auth'

function AuthTab() {
  const onSetAccessToken = useCallback<React.FormEventHandler<HTMLFormElement>>(e => {
    e.preventDefault()
    const { accessToken } = formToObject(e.currentTarget)
    if (accessToken) {
      (e.currentTarget.elements.namedItem('accessToken') as HTMLInputElement).value = ''
      setAuthTokenToCookies(accessToken)
      window.location.reload()
    }
  }, [])

  return <Pane padding={20}>
    <VerticalSpacer gap={16}>
      <Heading variant="heading5">Auth</Heading>

      <form onSubmit={onSetAccessToken}>
        <TextInput
          label="Set access token"
          helpText="Useful for logging into prod via local CP. Will reload the page."
          name="accessToken"
          required
          endIcon={<Clickable type="submit"><LineArrowRightIcon /></Clickable>}
        />
      </form>
    </VerticalSpacer>
  </Pane>
}

export default AuthTab
